<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="list-grade">
              <div>
                <label class="ml-3">Tell us a little bit about yourself</label>
                <br />
                <form class="ml-3 mr-3">
                  <textarea 
                    type="text"
                    class="custom-textarea" 
                    placeholder="I am a dedicated teacher with..."
                    v-model="aboutme.Content">
                  </textarea>
                </form>

                <div class="bottom-center">
                  <CButton style="
                    position: fixed;
                    bottom: 30px;
                    left: 0px;
                    right: 0px;
                    text-align: center;
                    margin: 0 auto;" 
                    class="btn-select-blue mt-5" 
                    @click="submitAbout(aboutme.Content)"> 
                      Save
                  </CButton>
                </div>
              </div>
              
              </div>

          </div>
        </div>
      </div>
    </CContainer>
      
    <div class="header-top">About Me</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

export default {
  data() {
    return {
      user: {},
      parent: {},
      aboutme: {},
      // aboutYou: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetParentProfile(this.user.id);
            this.GetTeacherProfessionalRegistered(this.user.id);
          }
        });
    },

    GetParentProfile() {
    this.$API
      .get(this.$ParentProfile + "?userId=" + this.user.id, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.parent = response.data;
        }
      });
    },

    GetTeacherProfessionalRegistered() {
    this.$API
      .get(this.$TeacherProfessionalRegistered + "?userId=" + this.user.id, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.aboutme = response.data;
          console.log("about", this.aboutme);
        }
      });
    },

    GoBack() {
      this.$router.back();
    },

    submitAbout(content)
    {
      const formData = new FormData();

      formData.append("teacherId", this.$route.query.teacherId);
      formData.append("content", content);
      
      return this.$API
        .post(this.$CreateEditProfessinalProfileByTeacherId, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            // this.Busy = false;
            // this.$dialog.alert("Success add").then(function () {});
            this.GoToMyResume(this.user.id);
            // this.list = true;
            // this.addnew = false;
          } else {
            this.Busy = false;
            // this.$dialog.alert("Error to add").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    GoToMyResume() {
      this.$router.push(
        "BTMyResume?teacherId=" + 
        this.$route.query.teacherId
      );
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.custom-textarea {
  width: 100%;
  height: 200px;
  padding: 10px 10px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 12px;
  resize: none;
}
</style>


